export default "/assets/b8ad5ddaf59b1382.png"